import * as React from 'react';
import { TagsCell } from './TagsCell';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderTagsCell = (data: any) => (
  <TagsCell data={data} />
  );
